import React from "react";

const items = ["GOLD", "SILVER", "DIAMOND", "KUNDAN", "POLKI", "BRIDAL SETS", "ANKLETS", "NECKLACES"];

export default function Marquee() {
    return (
        <div data-testid="marquee-ribbon" className="relative border-y border-gold/20 bg-obsidian-soft py-5 overflow-hidden">
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
                        {items.map((item) => (
                            <span key={`${copy}-${item}`} className="flex items-center">
                                <span className="font-display text-xl sm:text-2xl tracking-[0.2em] text-gold-light/80 px-6">
                                    {item}
                                </span>
                                <span className="w-1.5 h-1.5 rotate-45 bg-gold/60" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
